/**
 * Mock AI Insights data for development and testing
 */

export const mockAIModels = [
  // OpenAI models
  {
    id: 'gpt-4',
    name: 'GPT-4',
    provider: 'OpenAI',
    description: 'Most capable GPT model for complex tasks',
    isDefault: true
  },
  {
    id: 'gpt-3.5-turbo',
    name: 'GPT-3.5 Turbo',
    provider: 'OpenAI',
    description: 'Fast and efficient for most tasks',
    isDefault: false
  },
  
  // Anthropic models
  {
    id: 'claude-2',
    name: 'Claude 2',
    provider: 'Anthropic',
    description: 'Anthropic\'s advanced model with strong reasoning',
    isDefault: false
  },
  
  // Google Gemini models
  {
    id: 'gemini-pro',
    name: 'Gemini Pro',
    provider: 'Google',
    description: 'Google\'s advanced multimodal model',
    isDefault: false
  },
  {
    id: 'gemini-flash',
    name: 'Gemini Flash',
    provider: 'Google',
    description: 'Faster version of Gemini with good performance',
    isDefault: false
  },
  
  // Hugging Face models
  {
    id: 'mistral-7b-instruct',
    name: 'Mistral 7B Instruct',
    provider: 'Hugging Face',
    description: 'Open-source 7B parameter model with strong performance',
    isDefault: false
  },
  {
    id: 'llama-2-13b-chat',
    name: 'Llama 2 13B Chat',
    provider: 'Hugging Face',
    description: 'Meta\'s open-source 13B parameter chat model',
    isDefault: false
  },
  
  // DeepSeek models
  {
    id: 'deepseek-coder',
    name: 'DeepSeek Coder',
    provider: 'DeepSeek',
    description: 'Specialized for code generation and analysis',
    isDefault: false
  },
  
  // Cohere models
  {
    id: 'command-light',
    name: 'Command Light',
    provider: 'Cohere',
    description: 'Fast and efficient model for general tasks',
    isDefault: false
  },
  
  // Ollama models (for local deployment)
  {
    id: 'ollama-mistral',
    name: 'Mistral (Local)',
    provider: 'Ollama',
    description: 'Locally hosted Mistral model via Ollama',
    isDefault: false
  }
];

export const mockAIInsights = {
  prompt: `You are an AI assistant analyzing a Q&A session. Here is the context:

Question/Topic: How can we improve our development process?

Event Details:
- Status: ACTIVE / OPEN
- Type: Standard
- Visibility: Public
- Anonymous: No

Responses from participants (5 total):
- Response by John Doe on 2025-03-04:
  "We should adopt more automated testing practices."
  * Sentiment: positive
  * Votes: 3
  * Comments: 2

- Response by Jane Smith on 2025-03-04:
  "Code reviews are taking too long."
  * Sentiment: negative
  * Votes: 5
  * Comments: 3

As an expert facilitator, please provide a comprehensive analysis...`,
  
  rawResponse: `Here's my analysis of the Q&A session:

1. Key Themes & Patterns:
- Focus on automation and efficiency
- Concerns about review processes
- Emphasis on quality control

2. Sentiment Analysis:
- Mixed sentiment overall
- Positive towards automation
- Frustration with current processes

3. Notable Insights:
- Strong support for automated testing
- Review process needs optimization
- Team wants more efficient workflows

4. Action Items:
- Implement automated testing framework
- Review and optimize code review process
- Set up regular process improvement meetings

5. Engagement Analysis:
- Good participation rate
- High engagement via votes and comments
- Constructive discussion tone`,

  executiveSummary: 'This event received 85 responses with an overall positive sentiment. Participants expressed satisfaction with the new product features, but highlighted concerns about the pricing model and learning curve.',
  
  sentimentAnalysis: 'The overall sentiment of the responses was positive, with 65% of participants expressing satisfaction with the product. However, there were notable concerns about pricing and the learning curve that should be addressed.',
  
  sentimentScore: 'Positive (72%)',
  
  sentiment: {
    positive: 65,
    negative: 35
  },
  
  keyThemes: [
    'User Interface: Participants praised the intuitive design and easy navigation',
    'Pricing: Many users expressed concerns about the cost, especially for small teams',
    'Performance: Some users reported occasional lag and load time issues',
    'Feature Set: The new features were well-received, with suggestions for additional functionality'
  ],
  
  actionableInsights: [
    'Consider introducing a lower-priced tier for individual users and small teams',
    'Provide more tutorial content to help users navigate the learning curve',
    'Address the performance issues reported by several users',
    'Expand on the dashboard customization options that received positive feedback'
  ],
  
  nextSteps: [
    'Conduct follow-up interviews with users who mentioned pricing concerns',
    'Create a task force to investigate and resolve the reported performance issues',
    'Develop additional tutorial content focusing on advanced features',
    'Plan a webinar to showcase the new dashboard features that received positive feedback'
  ],
  
  modelUsed: 'gpt-4',
  generatedAt: new Date().toISOString(),
  responseCount: 85
};

export default {
  mockAIModels,
  mockAIInsights
};
